var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign-wheel",attrs:{"dir":_vm.direction}},_vm._l((_vm.signs),function(signInfo){return _c('text-sign',{key:signInfo.sign.signId,class:signInfo.class,attrs:{"sign":signInfo.sign}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }